import {
  SCOOTER_HISTORY_LOADING,
  SCOOTER_HISTORY_ERROR,
  SCOOTER_HISTORY_LIST,
  SCOOTER_HISTORY_FILTERS
} from "actions/scooter/history/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SCOOTER_HISTORY_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case SCOOTER_HISTORY_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case SCOOTER_HISTORY_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case SCOOTER_HISTORY_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooterHistoryReducer.js